import { render } from "./MenuComponent.vue?vue&type=template&id=3fcd708d&scoped=true"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"

import "./MenuComponent.vue?vue&type=style&index=0&id=3fcd708d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcd708d"]])

export default __exports__